import {computed, effect, Signal, signal} from "@angular/core";

export function debouncedSignal<T>(input: Signal<T>, timeOutMs = 0): Signal<T> {
  const debounceSignal = signal(input());
  let timeout = 0;
  effect(() => {
    const value = input();
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      debounceSignal.set(value);
    }, timeOutMs) as any;
  });
  return debounceSignal;
}

export function ignoreInitial<T>(signalFn: () => T): () => T | undefined {
  let isFirstRun = true;
  return computed(() => {
    const data = signalFn();
    if(isFirstRun) return undefined;
    return data;
  })
}
